import React from 'react';
import { useMediaQuery } from 'react-responsive';
import { Button } from '@fiverr-private/button';
import { I18n } from '@fiverr-private/i18n-react';
import { Container, Stack } from '@fiverr-private/layout_components';
import pathfinder from '@fiverr-private/pathfinder';
import { Text, Typography } from '@fiverr-private/typography';
import { theme } from '@fiverr-private/theme';
import { getContext } from '@fiverr-private/fiverr_context';
import { BQ_HOMEPAGE_CLICK } from '../../../utils/biEvents/events/bigQueryEvents';
import { sendBigQueryEvent, sendMixPanelEvent } from '../../../utils/biEvents';
import { MP_VIBE_CODING_BANNER_CLICKED } from '../../../utils/biEvents/events/mixPanelEvents';

export const Content = () => {
  const { queryParameters } = getContext();
  const buttonUrl = pathfinder(
    'vibe_coding_page',
    {},
    { query: { ...queryParameters, utm_source: 'lohp_banner', utm_medium: 'vibe_coding_banner' } }
  );

  const onButtonClick = () => {
    sendBigQueryEvent({
      eventName: BQ_HOMEPAGE_CLICK,
      params: { elementName: 'vibe_coding_banner', elementType: 'button' },
    });

    sendMixPanelEvent({
      eventName: MP_VIBE_CODING_BANNER_CLICKED,
      params: {},
    });
  };

  const isScreenSizeLessThanSm = useMediaQuery({ query: theme.breakpointsReverse.sm });

  return (
    <Stack direction="column" maxWidth="100%" width="100%" gap="4" position="relative" order={{ default: 2, md: 1 }}>
      <Typography
        as="h2"
        color="white"
        size={{ default: 'h_xl', sm: 'h_xxl', md: 'h_3xl', lg: 'h_3xl', xl: 'h_3xl' }}
        style={{ fontFamily: 'Macan', fontWeight: 280, lineHeight: '100%', letterSpacing: '-0.04em' }}
        textAlign={{ default: 'center', md: 'start' }}
      >
        <I18n k="logged_out_homepage.vibe_coding_banner.title" />
      </Typography>
      <Text size="b_md" color="white" textAlign={{ default: 'center', md: 'start' }}>
        <I18n k="logged_out_homepage.vibe_coding_banner.subtitle" />
      </Text>
      <Container textAlign={{ default: 'center', md: 'start' }}>
        <Button
          href={buttonUrl}
          target="_blank"
          size="lg"
          fullWidth={isScreenSizeLessThanSm}
          intent="secondary"
          variant="filled"
          colorScheme="white"
          onClick={onButtonClick}
        >
          <I18n k="logged_out_homepage.vibe_coding_banner.cta" />
        </Button>
      </Container>
    </Stack>
  );
};
